/**
 * Cookie helpers for values the SPA must set (e.g. anonymous session_id from WS).
 * Auth tokens stay HttpOnly and are never touched here.
 */

function getCookieDomain(): string {
  const host = typeof location !== "undefined" ? location.hostname : "";
  if (!host || host === "localhost") return "";
  if (/^\d{1,3}(\.\d{1,3}){3}$/.test(host)) return "";
  if (host.includes(":")) return "";

  const labels = host.split(".");
  if (labels.length < 2) return "";
  return labels.slice(-2).join(".");
}

/** Set a cookie readable by JS (not HttpOnly). Mirrors legacy static/js/cookies.js. */
export function setCookie(
  name: string,
  value: string,
  opts: { days?: number; path?: string; domain?: string } = {},
): void {
  const days = opts.days ?? 30;
  const path = opts.path ?? "/";
  const isHttps =
    typeof location !== "undefined" && location.protocol === "https:";
  const sameSite = isHttps ? "None" : "Lax";
  const domain = opts.domain ?? getCookieDomain();

  const segments = [`${name}=${value}`];
  if (days > 0) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    segments.push(`expires=${expires.toUTCString()}`);
  }
  segments.push(`path=${path}`);
  if (domain) segments.push(`domain=${domain}`);
  segments.push(`SameSite=${sameSite}`);
  if (isHttps || sameSite === "None") segments.push("Secure");

  document.cookie = segments.join("; ");
}
